// @flow
import { ClientsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    cliente: {},
    listaClientes: [],
    loading: false,
    error: false,
    formSubmited: false
};

type ClientesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { cliente?: {} | null, listaClientes?: [] | null, loading?: boolean, +value ?: boolean };

const Clientes = (state: State = INIT_STATE, action: ClientesAction): any => {
    // console.log(action);
    switch (action.type) {
        case ClientsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ClientsActionTypes.GET_CLIENT: {
                    return {
                        ...state,
                        cliente: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ClientsActionTypes.LIST_CLIENTS: {
                    return {
                        ...state,
                        listaClientes: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ClientsActionTypes.ADD_CLIENT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ClientsActionTypes.UPDATE_CLIENT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ClientsActionTypes.DELETE_CLIENT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ClientsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ClientsActionTypes.GET_CLIENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        cliente: {},
                        loading: false,
                    };
                }
                case ClientsActionTypes.LIST_CLIENTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaClientes: [],
                        loading: false,
                    };
                }
                case ClientsActionTypes.ADD_CLIENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ClientsActionTypes.UPDATE_CLIENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ClientsActionTypes.DELETE_CLIENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ClientsActionTypes.GET_CLIENT:
            return { ...state, error: false, loading: true };
        case ClientsActionTypes.LIST_CLIENTS:
            return { ...state, error: false, loading: true };
        case ClientsActionTypes.ADD_CLIENT:
            return { ...state, error: false, loading: true };
        case ClientsActionTypes.UPDATE_CLIENT:
            return { ...state, error: false, loading: true };
        case ClientsActionTypes.DELETE_CLIENT:
            return { ...state, error: false, loading: true };
        case ClientsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                cliente: {},
                listaClientes: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Clientes;
